import React from 'react';
import { PriceCard } from './Shared';
export const PriceSection = () => {
  return <section id="precio" className="bg-white py-10 px-5 sm:px-10" data-id="element-219">
      <div className="max-w-[1100px] mx-auto" data-id="element-220">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-biosync-text mb-10" data-id="element-221">
          "Tu sistema BIO-SYNC completo:"
        </h2>
        <PriceCard data-id="element-222" />
      </div>
    </section>;
};